<template>
  <div id="EdiAlloc">
    <div class="form-group row my-1">
      <label for="SearchClinics" class="col-sm-4 col-form-label-xs"
        >Pharmacy:</label
      >
      <div class="col-sm-7">
        {{ UserData.pharmacyno }} | {{ UserData.pharmacyname }}
      </div>
    </div>
    <form>
      <div class="form-group row my-0">
        <label for="UserID" class="col-sm-4 label-small my-0">Vaccine:</label>
        <div class="col-sm-8 my-0">
          {{ UserData.productdescription }}
        </div>
      </div>
      <div class="form-group row my-0">
        <label for="usernm" class="col-sm-4 label-small my-0"
          >Allocation Week:</label
        >
        <div class="col-sm-8 my-0">
          {{ UserData.allocweek | moment(UserData.allocweek) }}
        </div>
      </div>
      <div class="form-group row my-0 mt-1">
        <label class="col-sm-4 label-small">Delivery Date:</label>
        <div class="col-sm-8">
          {{ UserData.deliverydate | moment(UserData.deliverydate) }}
        </div>
      </div>
      <div class="form-group row my-0 mt-1">
        <label class="col-sm-4 label-small">Dosage Qty:</label>
        <div class="col-sm-8">
          <input
            id="usernm" type="number"
            v-model="dosageqty"
            placeholder="Dosage Qty"
            class="my-0 form-control form-control-xs"
          />
        </div>
      </div>
      <div class="form-group row my-0 mt-1" v-show="$v.dosageqty.$error">
        <label class="col-sm-4 label-small"></label>
        <div class="col-sm-8">
          <small class="sml-red" v-if="!$v.dosageqty.required"
            >Dosage qty required.
          </small>
            <small class="sml-red" v-if="!$v.dosageqty.numeric"
            >Valid qty is required.
          </small>
        </div>
      </div>
    </form>
    <hr />
    <div class="row">
      <div class="col-sm-6">
        <button v-on:click="UpdateAllocation" type="button" class="btn BtnSave btn-sml">
          <i class="fas fa-plus"></i> Update
        </button>
      </div>

      <div class="col-sm-6">
        <button v-on:click="Exit" type="button" class="btn BtnClose btn-sml">
          <i class="fas fa-times"></i> Close Form
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import Vuelidate from "vuelidate";
import { helpers } from "vuelidate/lib/validators";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
 
import {
  required,
  minLength,
  sameAs,
  not,
  maxLength,numeric
} from "vuelidate/lib/validators";
import { notEqual } from "assert";
Vue.use(Vuelidate);
const PasswordCheck = helpers.regex(
  "alphaNum",
  /(?=.{0,})((?=.*\d)(?=.*[a-z])(?=.*[A-Z])|(?=.*\d)(?=.*[a-zA-Z])(?=.*[\W_])|(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])).*/
);
export default {
  props: { UserData: Object },
  data: function () {
    return {
      dosageqty: "",
      Recid: "",
      DisableService: true,
      SelectedClinic: "",
      TypeHeadinptClass: "form-control form-control-xs",
      SearchClinics: "Search Clinics",
      datapickClass: "form-control form-control-xs my-0",
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      PWDminLength: 0,
      updateMessage: "",
      showUpdate: true,
      showOldPassword: true,
      uid: "",
      username: "",
      password: "",
      activeColor: "red",
      fontSize: 30,
      StartDate: "",
      EndDate: "",
      locnum: "",
      selectLocation: "",
      searchloc: "",
      Locations: [],
      location: "",
      loclist: "",
      selectService: "",
      Services: [],
      selectRole: "",
      Roles: [],
      Datepicker: "",
      adduser: "",
      exit: "",
      DateFormat: "",
      succeeded: false,
      Msg: "",
      showModal: false,
      ServiceType: "",
      UserClinicNo: "",
      UserServiceId: "",
    };
  },
  filters: {
    moment: function (date) {
      return moment(date, "YYYY-MM-DD").format("YYYY/MM/DD");
    },
    stringify(value) {
      return JSON.stringify(value, null, 2);
    },
  },
  watch: {},
  components: {
    Datepicker,
  },
  methods: {
    UpdateAllocation: function (event) {
      //console.log(this.UserData.vaxAllocdtlId)
      ////console.log(this.$v)
      ////console.log(this.$v.$invalid)
      this.$v.$touch(); 
      if (!this.$v.$invalid) {
        //  ////console.log('here')
        var vm = this;

        var url = "/SaskHealthApi/Codes/PostUpdateAllocation/";
        var params = {
          //_: Date.now(),
          AllocID: vm.UserData.vaxAllocdtlId,
          qty:vm.dosageqty
        };
        axios({
          method: "post",
          url: url,
          headers: {
            Authorization: "Bearer " + vm.$store.getters.GetAccessToken,
          },
          data: params,
        })
          .then(function (response) {
              vm.showMsg(response.data, "", "Allocation Confirmation"); 
          })
          .catch(function (error) { 
      if (er.status == 500) {
              vm.showMsg(
                "Error while processing your request, please contact system admin.",
                "",
                "Allocation Confirmation"
              );
            } else if (er.status == 400) {
              vm.showMsg(
                "Error while processing your request, please contact system admin.",
                "",
                "Allocation Confirmation"
          );
            }
          })
          .then(function () {});
      }
    },
    Exit: function (event) {
      this.$emit("finished");
    },
    showMsg(msg, data, Title) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxOk(msg, {
          title: Title,
          size: "md",
          buttonSize: "md",
          okVariant: "danger",
          okTitle: "Close",
          footerClass: "p-2",
          hideHeaderClose: true,
          hideHeaderCancel: true,
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
          if (value) {
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
  }, 
  mounted: function () {
    this.$nextTick(function () { 
    });
  }, 
  created: function () {
    //console.log(this.UserData);
    this.dosageqty = this.UserData.doseqty;
  },
  computed: {},
  validations() {
    return {
      dosageqty: {
        required,
        numeric
      },
    };
  },
};
</script>

<style scopped>
.calendarCss {
  width: 200px;
  padding: 0 !important;
  margin: 0 !important;
  background: #f3fafe;
}
.form-control-xs {
  height: calc(1.7em + 0.35rem + 1px) !important;
  padding: 0.15rem 0.25rem !important;
  font-size: 0.75rem !important;
  line-height: 1.5;
  border-radius: 0.2rem;
}
.label-small {
  vertical-align: super;
  font-size: small;
}

.modal-header {
  padding: 0.25rem !important;
  align-content: center;
  text-align: center !important;
}
.modal-footer {
  padding: 0.75rem !important;
}
.form-group {
  margin-bottom: 0;
}
/* @media (max-width: 600px) {
    .dropdown-menu{
          max-height:200px;
          overflow-y:auto;
       }
    } */
</style>
